<template>
    <div>

        <h4 class="block-title">Order Information</h4>
        <div class="checkout-list">
            <div v-if="isEmpty" class="text-center m-5">
                <h3>Cart is empty</h3>
                <a :href="'/' + pages.find(page => page.layout_name === 'rentals').slug" class="btn btn-primary mt-4">Find bikes to rent</a>
                <a :href="'/' + pages.find(page => page.layout_name === 'tours').slug" class="btn btn-primary mt-4">Find tours</a>
<!--                <a :href="'/' + pages.find(page => page.layout_name === 'events').slug" class="btn btn-primary mt-4">Find events</a>-->
            </div>
            <div v-else>
                <!-- BIKES -->
                <div v-if="bikes.length">
                    <div v-for="(bike, index) in bikes" :key="index" class="cart-item">
                        <div class="cart-item-container">
                            <img class="item-image d-md-block d-none" :src="bike.item.image.image ? bike.item.image.fullImage : '/assets/images/icons/no-image.png'" :alt="bike.title" :title="bike.title">
                            <div class="item-info">
                                <h4 class="title">{{ bike.item.type_name }}</h4>
                                <div class="dropdown d-inline">
                                    <a href="#" class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                        {{ bike.priceOption.time_option.period }} {{ bike.priceOption.time_option.type }}
                                    </a>
                                    <ul class="dropdown-menu dropdown-menu-end">
                                        <template v-for="(option, index) in bike.item.time_options_price">
                                            <li v-if="option.price">
                                                <a
                                                    class="dropdown-item"
                                                    href="javascript:void(0);"
                                                    @click="bike.priceOption = option">{{ option.time_option.period }} {{ option.time_option.type }}</a>
                                            </li>
                                        </template>
                                    </ul>
                                </div>
                                <a class="item-action-remove" href="javascript:void(0);" @click="removeBike(index)">
                                    <span class="bi bi-x-circle"></span> Remove
                                </a>
                            </div>
                            <div class="item-controls">
                                <NumberSelector :min="1" class="style-01" v-model="bike.amount" />
                                <h5 v-if="bike.item.discount > 0 && !promoCode" class="total"><span>{{ (bike.priceOption.price * bike.amount) | filterPrice }}</span>{{ (bike.priceOption.final_price  * bike.amount) | filterPrice }}</h5>
                                <h5 v-else class="total">{{ (bike.priceOption.price  * bike.amount) | filterPrice }}</h5>
                            </div>
                        </div>
                        <div v-if="bike.item.insurance" class="insurance-selector">
                            <div class="title">
                                <i class="bi bi-shield-check me-2 text-primary"></i>
                                <span>Insurance</span>
                                <h5 v-show="bike.insuranceAmount > 0" class="total text-primary m-0">+ {{ (bike.item.insurance  * bike.insuranceAmount) | filterPrice }}</h5>
                            </div>
                            <div class="item-controls">
                                <NumberSelector :min="0" :max="bike.amount" class="style-01 mt-0" v-model="bike.insuranceAmount" />
                            </div>
                        </div>
                    </div>
                </div>
                <!-- EVENTS -->
                <div v-if="events.length">
                    <div v-for="(bike, index) in events" :key="index" class="cart-item event item">
                        <div class="cart-item-container">
                            <img class="item-image d-md-block d-none" :src="bike.item.image.image ? bike.item.image.fullImage : '/assets/images/icons/no-image.png'" :alt="bike.item.type_name" :title="bike.item.type_name">
                            <div class="item-info">
                                <h4 class="title">{{ bike.item.type_name }}</h4>
<!--                                <div class="dropdown d-inline">-->
<!--                                    <div>-->
<!--                                       Event date: {{ dateEvent }}-->
<!--                                    </div>-->
<!--                                </div>-->
                                <div class="dropdown d-inline">
                                    <a href="#" class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                        {{ bike.priceOption.time_option.period }} {{ bike.priceOption.time_option.type }}
                                    </a>
                                    <ul class="dropdown-menu dropdown-menu-end">
                                        <template v-for="(option, index) in bike.item.event_time_option_price">
                                            <li v-if="option.price">
                                                <a
                                                    class="dropdown-item"
                                                    href="javascript:void(0);"
                                                    @click="bike.priceOption = option">{{ option.time_option.period }} {{ option.time_option.type }}</a>
                                            </li>
                                        </template>
                                    </ul>
                                </div>
                                <a class="item-action-remove" href="javascript:void(0);" @click="removeEventBike(index)">
                                    <span class="bi bi-x-circle"></span> Remove
                                </a>
                            </div>
                            <div class="item-controls">
                                <NumberSelector :min="1" class="style-01" v-model="bike.amount" />
                                <h5 v-if="bike.item.discount > 0 && !promoCode" class="total"><span>{{ (bike.priceOption.price * bike.amount) | filterPrice }}</span>{{ (bike.priceOption.final_price  * bike.amount) | filterPrice }}</h5>
                                <h5 v-else class="total">{{ (bike.priceOption.price  * bike.amount) | filterPrice }}</h5>
                            </div>
                        </div>
                        <div v-if="bike.item.insurance" class="insurance-selector">
                            <div class="title">
                                <i class="bi bi-shield-check me-2 text-primary"></i>
                                <span>Insurance</span>
                                <h5 v-show="bike.insuranceAmount > 0" class="total text-primary m-0">+ {{ (bike.item.insurance  * bike.insuranceAmount) | filterPrice }}</h5>
                            </div>
                            <div class="item-controls">
                                <NumberSelector :min="0" :max="bike.amount" class="style-01 mt-0" v-model="bike.insuranceAmount" />
                            </div>
                        </div>
                    </div>
                </div>
                <!-- TOURS -->
                <div v-if="tours.length">
                    <div v-for="(tour, index) in tours" :key="index" class="cart-item">
                        <div class="tour-item-container">
                            <div class="cart-item-container">
                                <img class="item-image d-md-block d-none" :src="tour.item.media_tours.length ? tour.item.media_tours[0].fullUrl : '/assets/images/icons/no-image.png'" :alt="tour.item.name" :title="tour.item.name">
                                <div class="item-info">
                                    <h4 class="title">{{ tour.item.name }}</h4>
                                    <div class="timeslot-picker">
                                        <span class="bi bi-calendar-date text-primary"></span>
                                        <DatePicker class="datepicker"
                                                    v-model="tour.slot.date"
                                                    color="red"
                                                    @input="changeTourDate"
                                                    :min-date="minDate"
                                                    :model-config="{
                                                        type: 'string',
                                                        mask: 'YYYY-MM-DD'
                                                    }"
                                                    :masks="{
                                                        // input: 'YYYY-MM-dd',
                                                        title: 'MMMM YYYY',
                                                        weekdays: 'WWW',
                                                        // data: ['YYYY-MM-DD']
                                                    }">
                                            <template v-slot="{ inputValue, inputEvents }">
                                                <a href="javascript:void(0);" v-on="inputEvents" class="filter-value">{{ inputValue }}</a>
                                            </template>
                                        </DatePicker>
                                        <div class="dropdown d-inline ms-2">
                                            <a href="#" class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                                {{ tour.slot.time }}
                                            </a>
                                            <ul class="dropdown-menu dropdown-menu-end">
                                                <li v-for="(slot, index) in timeSlots" :key="index">
                                                    <a
                                                        class="dropdown-item"
                                                        :class="{ disabled: !availableTimeSlot(timeSlots[index]) }"
                                                        href="javascript:void(0);"
                                                        @click="tour.slot.time = timeSlots[index]">{{ slot }}</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <a class="item-action-remove" href="javascript:void(0);" @click="removeTour(index)">
                                        <span class="bi bi-x-circle"></span> Remove
                                    </a>
                                </div>
                                <div class="item-controls">
                                    <h5 v-if="tour.item.discount && !promoCode" class="total"><span>{{ tour.item.price * tour.item.bike_types.reduce((total, i) => total + i.amount, 0) * tour.amount | filterPrice }}</span>{{ tour.item.final_price * tour.item.bike_types.reduce((total, i) => total + i.amount, 0) * tour.amount | filterPrice }}</h5>
                                    <h5 v-else class="total">{{ tour.item.price * tour.item.bike_types.reduce((total, i) => total + i.amount, 0) * tour.amount | filterPrice }}</h5>
                                </div>
                            </div>
                            <div class="bikes-list bikes-list_tours">
                                <div v-for="bike in tour.item.bike_types" :key="bike.id" class="cart-item">
                                    <div class="cart-item-container">
                                        <img class="item-image" :src="bike.bike_type.fullImage ? bike.bike_type.fullImage : '/assets/images/icons/no-image.png'" :alt="bike.bike_type.name" :title="bike.bike_type.name">
                                        <div class="item-info item-info_tours">
                                            <h4 class="title"><span class="text-primary">+</span> {{ bike.bike_type.name }}</h4>
                                            <div v-if="bike.bike_type['priceTourFormat'] !== undefined && bike.bike_type.priceTourFormat && parseInt(bike.amount) > 0">${{ (bikeTourPrice(tour, bike.bike_type.price_tour, bike.bike_type.priceTourFormat) * parseInt(bike.amount)).toFixed(2)  }}</div>
                                        </div>
                                        <div class="item-controls item-controls_tours">
                                            <NumberSelector :min="0" class="style-01" v-model="bike.amount" />
                                        </div>
                                    </div>
                                    <div v-if="bike.bike_type.insurance" class="cart-item-container">
                                        <div class="item-info">
                                            <h5>
                                                <i class="bi bi-shield-check me-2 text-primary"></i>
                                                Insurance
                                                <span v-show="bike.insuranceAmount > 0" class="total">+{{ (bike.bike_type.insurance  * bike.insuranceAmount) | filterPrice }}</span>
                                            </h5>
                                        </div>
                                        <div class="item-controls">
                                            <NumberSelector :min="0" :max="bike.amount" class="style-01 mt-0" v-model="bike.insuranceAmount" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <CheckoutAccessories v-if="!isEmpty" class="mt-5" :is-event="events.length > 0" :event-id="events.length ? this.events[0].item.event_id : 0"/>
        <CheckoutMerchandises v-if="!isEmpty" class="mt-5"/>
        <CheckoutAdditionalOptions v-if="!isEmpty" class="mt-5" :is-event="events.length > 0" :event-id="events.length ? this.events[0].item.event_id : 0"/>
    </div>
</template>

<script>
import { DateTime } from "luxon";
import CheckoutAccessories from "./CheckoutAccessories";
import NumberSelector from "../../elements/NumberSelector";
import {mapActions, mapGetters} from "vuex";
import CheckoutAdditionalOptions from "./CheckoutAdditionalOptions";
import DatePicker from "v-calendar/lib/components/date-picker.umd.min";
import CheckoutMerchandises from "./CheckoutMerchandises";

export default {
    name: "CheckoutOrderInformation",
    props: {
        pages: {
            type: Array
        }
    },
    components: {
        CheckoutMerchandises,
        DatePicker,
        CheckoutAdditionalOptions,
        NumberSelector,
        CheckoutAccessories,
    },
    computed: {
        ...mapGetters('cart', ['bikes', 'tours', 'events', 'promoCode', 'isEmpty']),
        ...mapGetters('app', ['targetDate']),
        timeSlots() {
            return this.tours.length ? [...new Set(this.tours[0].item.time_slots.map(item => DateTime.fromFormat(item, 'yyyy-MM-dd HH:mm').toFormat('HH:mm')))].sort() : [];
        },
        minDate() {
            for(let s of this.timeSlots) {
                if (this.availableTimeSlot(s)) {
                    return DateTime.fromFormat(s, 'HH:mm').toFormat('yyyy-MM-dd');
                }
            }
            return DateTime.now().plus({ days: 1 }).toFormat('yyyy-MM-dd');
        },
        currentDate() {
            const currentDate = this.$store.getters['app/targetDate'];

            if(currentDate) {
                const date = DateTime.fromISO(currentDate)
                return date.toFormat('yyyy-MM-dd');
            }
            return '';
        },
        dateEvent() {
            return DateTime.now().toFormat('yyyy-MM-dd')
        }
    },
    watch: {
        bikes: {
            handler(value) {
                this.$store.commit('cart/SET_BIKES', value);
            },
            deep: true
        },
        events: {
            handler(value) {
                this.$store.commit('cart/SET_EVENTS', value);
            },
            deep: true
        },
        tours: {
            handler(newValue, oldValue) {
                this.$store.commit('cart/SET_TOURS', newValue);
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        ...mapActions('cart', ['removeBike', 'removeTour', 'removeEventBike']),
        availableTimeSlot(timeSlot) {
            return DateTime.now() < DateTime.fromFormat(this.tours[0].slot.date + ' ' + timeSlot, 'yyyy-MM-dd HH:mm')
        },
        changeTourDate(value) {
            if(value) {
                const currentDate = DateTime.fromFormat(value, 'yyyy-MM-dd').toISO({ includeOffset: false });
                this.$store.commit('app/SET_TARGET_DATE', currentDate);
            }
        },
        bikeTourPrice(tour, value, valueFormat) {
            const floatValue = parseFloat(value);
            const floatValueFormat = parseFloat(valueFormat);
            if (tour.item.discount && !this.promoCode) {
                return floatValue >= 0 ? floatValueFormat : ((tour.item.final_price - Math.abs(floatValue))/100).toFixed(2);
            } else {
                return floatValue >= 0 ? floatValueFormat : ((tour.item.price - Math.abs(floatValue))/100).toFixed(2);
            }
        },
    },
    mounted() {
        if (this.tours.length) {
            this.tours[0].slot.date = this.currentDate ? this.currentDate : DateTime.now().toFormat('yyyy-MM-dd');
            this.tours[0].slot.date = this.currentDate ? this.currentDate : this.minDate;
            for(let s of this.timeSlots) {
                if (this.availableTimeSlot(s)) {
                    this.tours[0].slot.time = DateTime.fromFormat(s, 'HH:mm').toFormat('HH:mm');
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
